export const topics = [
  "iOS app",
  "Photo editing",
  "Photo gear",
  "Cinema",
  "Post-processing",
  "Others",
];
